module.exports = __webpack_public_path__ + "static/media/icon-CAD.b346ae3e.svg";